export default class Uploader {
    private $el: JQuery;

    private $input: JQuery;
    private $inputvalue: JQuery;
    private $label: JQuery;
    private $drop: JQuery;
    private $text: JQuery;

    private options;

    public constructor($el: JQuery, options) {
        this.options = options || {};

        this.$el = $el;

        this.initHtml();
    }

    public initHtml(): void {
        this.$el.data('uploader', this);

        this.$inputvalue = $('> input', this.$el);
        this.$label = $('label', this.$el);
        this.$drop = $('.uploader__drop', this.$el);
        this.$text = $('.uploader__text', this.$el);

        const name = this.$el.data('name');

        this.$input = $('<input type="file" name="' + name + '">');
        this.$input.appendTo(this.$label);

        this.$text.html(this.$inputvalue.val().toString());

        // var cb_change = [];

        // this.onChange=function (callback) {
        //     cb_change.push(callback);
        // }

        this.$el.prepend(this.$inputvalue);

        this.$input.on('change', (e) => {
            this.upload();
        });

        this.$drop.on('drag dragstart dragend dragover dragenter dragleave drop', (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        this.$drop.on('dragover dragenter', () => {
            this.$el.addClass('uploader--dragover');
        });

        this.$drop.on('dragleave dragend drop', () => {
            this.$el.removeClass('uploader--dragover');
        });

        this.$drop.on('drop', (e) => {
            const droppedFiles = (<any>e.originalEvent).dataTransfer.files;

            this.upload(droppedFiles);
        });
    }

    public upload(droppedFiles?: FileList): void {
        if (this.$el.hasClass('uploader--uploading')) {
            return;
        }

        this.$el.addClass('uploader--uploading');
        this.$el.removeClass('uploader--success uploader--error');

        const $form = $('<form method="post" enctype="multipart/form-data">');
        const form: HTMLFormElement = <HTMLFormElement>$form[0];

        $form.appendTo($('body'));

        if (!droppedFiles) {
            this.$input.appendTo($form);
        }

        const ajaxData = new FormData(form);

        if (droppedFiles) {
            $.each(droppedFiles, (i, file) => {
                ajaxData.append(this.$input.prop('name'), file);
            });
        }

        // if (options.onStart) {
        //     options.onStart();
        // }

        const url = this.options.url || this.$el.data('url');

        $.ajax({
            url: url,
            type: 'post',
            data: ajaxData,
            cache: false,
            contentType: false,
            processData: false,

            complete: () => {
                this.$el.removeClass('uploader--uploading');
            },

            success: (data) => {
                if (data != null && data.success != null) {
                    if (data.value != null) {
                        this.$inputvalue.val(data.value);
                    } else {
                        this.$inputvalue.val('');
                    }

                    if (data.text != null) {
                        this.$text.html(data.text);
                    } else {
                        this.$text.empty();
                    }

                    if (data.success) {
                        this.$el.addClass('uploader--success');

                        // if (options.onSuccess) {
                        //     options.onSuccess(data);
                        // }
                    } else {
                        this.$el.addClass('uploader--error');

                        // if (options.onError) {
                        //     options.onError(data);
                        // }
                    }

                    // $.each(cb_change, function (i, callback) {
                    //     callback(data);
                    // });
                }
            },

            error: () => {
                this.$text.text('Błąd połączenia');
                this.$inputvalue.val('');
            }
        });

        this.$input.appendTo(this.$label);
        this.reset();
    }

    public reset() {
        this.$input.val('');
        this.$inputvalue.val('');
    }

    public static init(): void {
        $(() => {
            (<any>window).Uploader = Uploader;
        });
    }
}
